export const frontend_backend = [
  { icon: "https://iamsanjaygupta.github.io/static/media/html.323dab0ccafeb98fae45.png", name: "HTML" },
  { icon: "https://i.pinimg.com/564x/3c/2a/ad/3c2aadf4b1aeffa2bc631eb2037a2496.jpg", name: "CSS" },
  { icon: "https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg", name: "JavaScript" },
  {
    icon: "https://www.coffeeclass.io/logos/chakra-ui.png", name: "Chakra UI",
  },
  { icon: "https://hackersandslackers-cdn.storage.googleapis.com/2020/05/express.png", name: "Express" },
  { icon: "https://cdn.iconscout.com/icon/free/png-512/mongodb-3521676-2945120.png", name: "MongoDB" },
  { icon: "https://i.pinimg.com/564x/3c/2a/ad/3c2aadf4b1aeffa2bc631eb2037a2496.jpg", name: "Mongoose" },
  
   
  ];

  export const frameWork_tools = [
    { icon: "https://i.pinimg.com/236x/da/1c/1b/da1c1ba16e52114d1a59e9ad666a4ae6.jpg", name: "React" },
    { icon: "https://cdn.worldvectorlogo.com/logos/redux.svg", name: "Redux" },
    { icon: "https://i.pinimg.com/564x/0d/59/22/0d5922d05bf2866c850a470f3ee84c0b.jpg", name: "npm" },
    { icon: "https://i.pinimg.com/564x/53/3f/56/533f563a106e3428115a214d9b690717.jpg", name: "Git & Github" },
    { icon: "https://hackr.io/tutorials/data-structures-algorithms/logo-data-structures-algorithms.svg?ver=1587721467", name: "DSA"},
   
  ];
